export default __webpack_public_path__ + "static/media/linkedin-textonly-white.d83942fb.svg";